var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarmGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7507 19.735V12.5884C21.7507 8.09229 18.6322 4.33301 14.4416 3.33077V2.34425C14.4416 1.11851 13.4481 0.125 12.2224 0.125C10.9967 0.125 10.0014 1.11851 10.0014 2.34425V3.33077C5.8126 4.33301 2.69413 8.09229 2.69413 12.5884V19.735L0.3125 24.5H24.1323L21.7507 19.735Z",
    fill: "#A3B0B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9993 26.7188C16.9993 29.223 14.9692 31.2531 12.465 31.2531C9.96076 31.2531 7.93066 29.223 7.93066 26.7188H16.9993Z",
    fill: "#A3B0B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmGray);
export default __webpack_public_path__ + "static/media/alarm_gray.0f88830422af4f8dc6e6546871662d4f.svg";
export { ForwardRef as ReactComponent };